import React from 'react';
import { connect as connectFormik } from 'formik';
import { Icon } from '../../web.common';
import ReactSelect from 'react-select';
import { weekdays } from '../../enums/weekdays';

class EditOpeningHoursBase extends React.Component {
  constructor() {
    super();
    this.state = {
      editingDay: weekdays[0]
    };
  }

  onblur(editingFrom, key) {
    if (!editingFrom.match(/\d\d:\d\d/)) {
      this.setState({ [`${key}`]: '00:00' });
    }
  }

  remove(index) {
    const { formik } = this.props;
    const { values, setFieldValue, setFieldTouched } = formik;
    const { PlaceOpeningHours } = values;

    const edited = JSON.parse(JSON.stringify(PlaceOpeningHours));
    edited.splice(index, 1);

    setFieldValue('PlaceOpeningHours', edited);
    setFieldTouched('PlaceOpeningHours', true);
  }

  edit(index, editingFrom, editingTo) {
    const { formik } = this.props;
    const { values, setFieldValue, setFieldTouched } = formik;
    const { PlaceOpeningHours } = values;

    const edited = JSON.parse(JSON.stringify(PlaceOpeningHours));
    edited[index].OpensAt = editingFrom;
    edited[index].ClosesAt = editingTo;
    setFieldValue('PlaceOpeningHours', edited);
    setFieldTouched('PlaceOpeningHours', true);
    this.setState({
      editing: null
    });
  }

  add(PlaceOpeningHours) {
    this.setState({
      editing: PlaceOpeningHours.length,
      editingFrom: '10:00',
      editingTo: '20:00'
    });
  }

  startEditing(index, OpensAt, ClosesAt) {
    this.setState({
      editing: index,
      editingFrom: OpensAt.substring(0, 5),
      editingTo: ClosesAt.substring(0, 5)
    });
  }

  confirm() {
    const { formik } = this.props;
    const { editingFrom = '', editingTo = '', editingDay } = this.state;
    const { values, setFieldValue, setFieldTouched } = formik;
    const { PlaceOpeningHours } = values;

    const newEntry = {
      OpensAt: editingFrom,
      ClosesAt: editingTo,
      Day: editingDay.value
    };
    const edited = JSON.parse(JSON.stringify(PlaceOpeningHours));
    edited.push(newEntry);

    setFieldValue('PlaceOpeningHours', edited);
    setFieldTouched('PlaceOpeningHours', true);

    this.setState({
      editing: null
    });
  }

  renderAddOpeningHour() {
    const { formik } = this.props;
    const { editingFrom = '', editingTo = '', editingDay } = this.state;
    const { values } = formik;
    const { PlaceOpeningHours } = values;

    return (
      <li>
        <div className='react-select-outer'>
          <div className='react-select-outer'>
            <ReactSelect
              className='react-select-opening-hours'
              classNamePrefix='react-select-opening-hours-prefix'
              onChange={selection => {
                this.setState({ editingDay: selection });
              }}
              value={editingDay}
              name='editing-hour-day'
              options={weekdays}
            />
          </div>
        </div>

        <input
          className='editing-hour-from'
          name={`editing-hour-from-${PlaceOpeningHours.length}`}
          value={editingFrom}
          onChange={event => this.setState({ editingFrom: event.target.value })}
          onBlur={() => this.onblur(editingFrom, 'editingFrom')}
        />

        <span> - </span>

        <input
          className='editing-hour-to'
          name={`editing-hour-to-${PlaceOpeningHours.length}`}
          value={editingTo}
          onChange={event => {
            this.setState({ editingTo: event.target.value });
          }}
          onBlur={() => this.onblur(editingTo, 'editingTo')}
        />

        <span className='icon-confirm' onClick={() => this.confirm()}>
          <Icon className='true' iconName='check' />
        </span>

        <span className='icon-undo' onClick={() => this.setState({ editing: null })}>
          <Icon className='true' iconName='undo' />
        </span>
      </li>
    );
  }

  renderShowOpeningHourRow(Day, OpensAt, ClosesAt, index) {
    const openTimeFormatted = OpensAt.substring(0, 5);
    const closeTimeFormatted = ClosesAt.substring(0, 5);
    const { editing } = this.state;

    return (
      <li>
        <b>{Day}</b>
        :
        <span style={{ marginLeft: '5px' }}>
          {openTimeFormatted}
          {' '}
          -
          {' '}
          {closeTimeFormatted}
        </span>

        {
          editing ? ''
            : (
              <span className='icon-edit' onClick={() => this.startEditing(index, OpensAt, ClosesAt)}>
                <Icon iconName='edit' />
              </span>
            )
        }
        {editing ? ''
          : (
            <span className='icon-remove' onClick={() => this.remove(index)}>
              <Icon iconName='times' />
            </span>
          )
        }
      </li>
    );
  }

  renderEditOpeningHourRow(Day, index) {
    const { editingFrom = '', editingTo = '' } = this.state;

    return (
      <li>
        <b>{Day}</b>
        :
        <input
          pattern='\d\d:\d\d'
          onBlur={() => this.onblur(editingFrom, 'editingFrom')}
          className='editing-hour-from'
          name={`editing-hour-from-${index}`}
          value={editingFrom}
          onChange={event => this.setState({ editingFrom: event.target.value })}
        />
        <span> - </span>
        <input
          pattern='\d\d:\d\d'
          onBlur={() => this.onblur(editingTo, 'editingTo')}
          className='editing-hour-to'
          name={`editing-hour-to-${index}`}
          value={editingTo}
          onChange={event => this.setState({ editingTo: event.target.value })}
        />
        <span
          className='editing-hour-confirm'
          onClick={() => this.edit(index, editingFrom, editingTo)}
        >
          <Icon className='icon-confirm' iconName='check' />
        </span>
        <span onClick={() => {
          this.setState({
            editing: null
          });
        }}
        >
          <Icon className='true' iconName='undo' />
        </span>
      </li>
    );
  }

  render() {
    const { formik } = this.props;
    const { editing } = this.state;
    const { values } = formik;
    const { PlaceOpeningHours } = values;
    const isAddingNew = editing === PlaceOpeningHours.length;

    return (
      <React.Fragment>
        <ul className='edit-opening-hours'>
          {
            PlaceOpeningHours.map(({ Day, OpensAt, ClosesAt }, index) => (editing === index
              ? this.renderEditOpeningHourRow(Day, index)
              : this.renderShowOpeningHourRow(Day, OpensAt, ClosesAt, index)))}

          {
            editing ? ''
              : (
                <span className='icon-add' onClick={() => this.add(PlaceOpeningHours)}>
                  <Icon className='true' iconName='plus' />
                </span>
              )
          }
          {
            !isAddingNew ? '' : this.renderAddOpeningHour()
          }
        </ul>
      </React.Fragment>
    );
  }
}

export const EditOpeningHours = connectFormik(EditOpeningHoursBase);